/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:00:22
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { mapActions, mapGetters } from 'vuex';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import SmallLoadingSpinner from '@/components/Common/SmallLoadingSpinner';
import LoginErrorMessage from '@/components/Login/LoginErrorMessage';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'LoginCreatePasswordForm',

  components: {
    LoginErrorMessage, SmallLoadingSpinner,
  },

  props: ['loginCredentialsIncorrect', 'loginLoadingActive'],

  data() {
    return {
      newPassword: null,
      passwordRepeat: null,
      passwordHidden: true,
      lengthRequirementMet: false,
      digitRequirementMet: false,
      lowercaseRequirementMet: false,
      uppercaseRequirementMet: false,
    };
  },

  beforeMount() {
    this.resetPasswords();
  },

  computed: {
    ...mapGetters(['authType']),
  },

  methods: {
    ...mapActions(['setPassword', 'undoLoginState', 'submitSetNewPassword']),
    async submitNewPassword() {
      const newPassword = this.newPassword;
      if (this.authType === 'createNewPasswordForRegisteredUser') {
        await this.submitSetNewPassword({ newPassword });
        this.$toaster.success('Hasło zostało zmienione');
      } else {
        await this.setPassword({ newPassword });
        this.$toaster.success('Hasło zostało zapisane. Możesz się teraz zalogować');
      }
    },
    togglePasswordVisiblity() {
      if (this.passwordHidden) {
        document.querySelector('.login-form__input--password').type = 'text';
        this.passwordHidden = false;
      } else {
        document.querySelector('.login-form__input--password').type = 'password';
        this.passwordHidden = true;
      }
    },
    resetPasswords() {
      this.newPassword = null;
      this.passwordRepeat = null;
    },
    togglePasswordVisibility() {
      if (this.passwordHidden) {
        document.querySelectorAll('.login-form__input--password').forEach(element => {
          element.type = 'text';
        });
        this.passwordHidden = false;
      } else {
        document.querySelectorAll('.login-form__input--password').forEach(element => {
          element.type = 'password';
        });
        this.passwordHidden = true;
      }
    },
    handlePasswordInput(event) {
      const text = event.target.value;
      this.lengthRequirementMet = text.length >= 8;
      this.digitRequirementMet = /\d/.test(text);
      this.lowercaseRequirementMet = (/[a-z]/).test(text);
      this.uppercaseRequirementMet = (/[A-Z]/).test(text);
      document.querySelector("#length-requirement").style.color = this.lengthRequirementMet ? "#008A00" : "#FF4539";
      document.querySelector("#digit-requirement").style.color = this.digitRequirementMet ? "#008A00" : "#FF4539";
      document.querySelector("#lowercase-requirement").style.color = this.lowercaseRequirementMet ? "#008A00" : "#FF4539";
      document.querySelector("#uppercase-requirement").style.color = this.uppercaseRequirementMet ? "#008A00" : "#FF4539";
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Login/LoginCreatePasswordForm/component.js